<template>
  <div class="p-learning-result">
    <div class="p-learning-result__head">
      <div class="p-learning-result__head__inner">
        <div class="question c-markdown-area">
          <plain-text-view :markdown-text="title" :prefix="prefix"></plain-text-view>
      </div>
      </div>
    </div>
    <div class="p-learning-result__body">
      <div class="p-learning-result__body__inner">
        <ul class="guide">
          <li class="item item--color1">初回学習で全問正答</li>
          <li class="item item--color2">初回学習で誤答あり/復習で全問正答</li>
          <li class="item item--color3">誤答あり</li>
          <li class="item item--color4">未学習</li>
        </ul>
      </div>
      <div class="c-table-fixed-header-footer-wrapper">
        <table class="c-table-fixed-header-footer -progress">
          <thead>
            <tr>
              <th class="id"><div class="spacer">出席番号</div></th>
              <th class="name">名前</th>
              <th
                v-for="(header, index) in progressStatus.headers_and_footers"
                :key="index"
                class="num"
              >
                <a
                  :href="headerLink(header)"
                  :title="longTitle(header)"
                ><plain-text-view class="header_title" :markdown-text="header.title"></plain-text-view>
                </a>
              </th>
              <th data-copy-ignore><div class="spacer"></div></th>
            </tr>
          </thead>
          <tbody class="vaMiddle">
            <tr
              v-for="student in progressStatus.students"
              :key="`${student.name}-${student.number}`"
            >
              <th>{{ student.number }}</th>
              <th>{{ student.name }}</th>
              <td
                v-for="progressStatusBlock in student.progress_status_blocks"
                :key="progressStatusBlock.aggregation_id"
              >
                <ul class="bars">
                  <li
                    v-for="(status, gaugeIndex) in progressStatusBlock.statuses"
                    :key="`${student.number}-${progressStatusBlock.aggregation_id}-${gaugeIndex}`"
                    :class="`item item--${gaugeColorMap[status]}`"
                  ></li>
                </ul>
              </td>
              <td></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">初回正答率（平均）</th>
              <td
                v-for="(footer, index) in progressStatus.headers_and_footers"
                :key="index"
              >{{ footer.correct_answer_rate_initial }}%</td>
              <td></td>
            </tr>
            <tr data-copy-ignore>
              <th colspan="2"><div class="spacer"></div></th>
              <td
                v-for="numberOfBlock in numberOfProgressStatusBlocks"
                :key="numberOfBlock"
              ></td>
              <th><div class="spacer"></div></th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";

  // FIXME: 生徒一覧の v-for の key は backend から user.uuid か student.id を返してもらうのが良さそう
  const props = defineProps<{
    title: string;
    prefix: string;
    progressStatus: any;
  }>()

  // cf. teacher_learning_progress.consts.CorrectAnswer
  const gaugeColorMap =  ref<{ [progressStatus: number] : string }> ({
    1: "color1",
    2: "color2",
    3: "color3",
    4: "color4",
  })

  const  numberOfProgressStatusBlocks = computed(() => {
    return props.progressStatus.headers_and_footers.length
  })

  function longTitle(header) {
    return header.hasOwnProperty("text") ? header.text : header.title
  }

  function getQueryString(queryParams) {
    // 渡されたクエリパラメータ用データをクエリ文字列化する
    return (Object.entries(queryParams)
      .map(queryParam => `${queryParam[0]}=${queryParam[1]}`)
    )
  }

  function headerLink(header) {
    let url = new URL(location.toString())
    let params = url.searchParams

    // クエリパラメータに出題単位idの指定があれば小問正誤リストのリンクを返す
    if (params.has("question_set_id")) {
        return (url + "&" + getQueryString({question_id: header.id}))
      }
    // クエリパラメータに孫項目idの指定があれば出題単位進捗リストのリンクを返す
    if (params.has("section_id")) {
        return (url + "&" + getQueryString({question_set_id: header.id}))
      }
    // クエリパラメータに子項目idの指定があれば孫項目進捗リストのリンクを返す
    if (params.has("chapter_id")) {
        return (url + "&" + getQueryString({section_id: header.id}))
      }
  }
</script>

<style lang="scss" scoped>
</style>
